import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { RecoilRoot } from "recoil";
import "./input.css";
import AdminProductDetail from "./pages/admin_business_info/AdminProductDetail";
import AdminSolutionDetail from "./pages/admin_business_info/AdminSolutionDetail";
import AdminSolutionDetailChild from "./pages/admin_business_info/AdminSolutionDetailChild";
import { AdminCertification } from "./pages/admin_company_info/AdminCertification";
import AdminProduct from "./pages/admin_company_info/AdminProduct";
import AdminSolution from "./pages/admin_company_info/AdminSolution";
import { AdminCompanyHistory } from "./pages/admin_company_info/company_history/AdminCompanyHistory";
import { AdminAS } from "./pages/admin_customer_support/AdminAS";
import { AdminDoc } from "./pages/admin_customer_support/AdminDoc";
import { AdminSales } from "./pages/admin_customer_support/AdminSales";
import { AdminASComplementForm } from "./pages/admin_customer_support/admin_as/AdminASComplementForm";
import { AdminASPostForm } from "./pages/admin_customer_support/admin_as/AdminASPostForm";
import { AdminDocComplementForm } from "./pages/admin_customer_support/admin_documentary/AdminDocComplementForm";
import { AdminDocPostForm } from "./pages/admin_customer_support/admin_documentary/AdminDocPostForm";
import { AdminComplementForm } from "./pages/admin_customer_support/admin_sales_inquiry/AdminComplementForm";
import { AdminPostForm } from "./pages/admin_customer_support/admin_sales_inquiry/AdminPostForm";
import { AdminAnnouncement } from "./pages/admin_announcement/AdminAnnouncement";
import { AdminAnnouncementComplementForm } from "./pages/admin_announcement/AdminAnnouncementComplementForm";
import { AdminAnnouncementPostForm } from "./pages/admin_announcement/AdminAnnouncementPostForm";
import { AdminVideos } from "./pages/admin_video/AdminVideos";
import AdminLogin from "./pages/amdin/AdminLogin";
import AdminMain from "./pages/amdin/AdminMain";
import { Product } from "./pages/business_info/Product";
import ProductDetail from "./pages/business_info/ProductDetail";
import { Solution } from "./pages/business_info/Solution";
import SolutionDetail from "./pages/business_info/SolutionDetail";
import SolutionDetailChlid from "./pages/business_info/SolutionDetailChild";
import { CEOIntroduction } from "./pages/company_info/CEOIntroduction";
import { Certification } from "./pages/company_info/Certification";
import CiBi from "./pages/company_info/CiBi";
import { CompanyHistory } from "./pages/company_info/company_history/CompanyHistory";
import { Map } from "./pages/company_info/Map";
import { AS } from "./pages/customer_support/AS";
import { ASComplementForm } from "./pages/customer_support/as_inquiry/ASComplementForm";
import { ASPostForm } from "./pages/customer_support/as_inquiry/ASPostForm";
import { Documentary } from "./pages/customer_support/Documentary";
import { DocComplementForm } from "./pages/customer_support/documentary_inquiry/DocComplementForm";
import { Sales } from "./pages/customer_support/Sales";
import { ComplementForm } from "./pages/customer_support/sales_inquiry/ComplementForm";
import { PostForm } from "./pages/customer_support/sales_inquiry/PostForm";
import Main from "./pages/Main";
import { Announcement } from "./pages/announcement/Announcement";
import { AnnouncementComplementForm } from "./pages/announcement/AnnouncementComplementForm";
import { Videos } from "./pages/video/Videos";
const colors = {
    brand: {
        900: "#1a365d",
        800: "#153e75",
        700: "#2a69ac",
    },
};

const theme = extendTheme({ colors });

function App() {
    return (
        <ChakraProvider theme={theme}>
            <div className="App">
                <ChakraProvider>
                    <RecoilRoot>
                        <BrowserRouter>
                            <Routes>
                                <Route path="/" element={<Main />}></Route>
                                {/* admin_company_info */}
                                {/* admin */}
                                <Route path="/admin" element={<AdminMain />}></Route>
                                <Route path="/admin/login" element={<AdminLogin />}></Route>
                                <Route path="/admin/certification" element={<AdminCertification />}></Route>
                                {/* admin_videos */}
                                <Route path="/admin/video" element={<AdminVideos />}></Route>
                                {/* company_info */}
                                <Route path="/company-info/ceo-introduction" element={<CEOIntroduction />}></Route>
                                <Route path="/company-info/certification" element={<Certification />}></Route>
                                <Route path="/company-info/cibi" element={<CiBi />}></Route>
                                <Route path="/company-info/map" element={<Map />}></Route>
                                <Route path="/company-info/history" element={<CompanyHistory />}></Route>
                                {/* business */}
                                <Route path="/business/product" element={<Product />}></Route>
                                <Route path="/business/solution" element={<Solution />}></Route>
                                <Route path="/business/product-detail" element={<ProductDetail />}></Route>
                                <Route path="/business/solution-detail" element={<SolutionDetail />}></Route>
                                <Route path="/business/subject-detail" element={<SolutionDetailChlid />}></Route>

                                {/* admin_business */}
                                <Route path="/admin/product" element={<AdminProduct />}></Route>
                                <Route path="/admin/solution" element={<AdminSolution />}></Route>
                                <Route path="/admin/product-detail" element={<AdminProductDetail />}></Route>
                                <Route path="/admin/solution-detail" element={<AdminSolutionDetail />}></Route>
                                <Route path="/admin/subject-detail" element={<AdminSolutionDetailChild />}></Route>

                                {/* customer */}
                                <Route path="/customer/as" element={<AS />}></Route>
                                <Route path="/customer/as-post" element={<ASPostForm />}></Route>
                                <Route path="/customer-as/*" element={<ASComplementForm />}></Route>

                                {/* customer-documentary */}
                                <Route path="/customer/documentary" element={<Documentary />}></Route>
                                <Route path="/customer-documentary/*" element={<DocComplementForm />}></Route>

                                {/* customer-sales */}
                                <Route path="/customer/sales" element={<Sales />}></Route>
                                <Route path="/customer/post" element={<PostForm />}></Route>
                                <Route path="/customer-sales/*" element={<ComplementForm />}></Route>

                                {/* announcement */}
                                <Route path="/announcement/*" element={<AnnouncementComplementForm />}></Route>
                                <Route path="/announcement" element={<Announcement />}></Route>

                                {/* video */}
                                <Route path="/video" element={<Videos />}></Route>

                                {/* admin_company_history */}
                                <Route path="/admin/company-history" element={<AdminCompanyHistory />}></Route>

                                {/* admin-announcement */}
                                <Route
                                    path="/admin-post-announcement/*"
                                    element={<AdminAnnouncementComplementForm />}
                                ></Route>
                                <Route path="/admin-post-announcement" element={<AdminAnnouncementPostForm />}></Route>
                                <Route path="/admin/announcement" element={<AdminAnnouncement />}></Route>

                                {/* admin-documentary */}
                                <Route path="/admin-post-documentary/*" element={<AdminDocComplementForm />}></Route>
                                <Route path="/admin-post-documentary" element={<AdminDocPostForm />}></Route>
                                <Route path="/admin/documentary" element={<AdminDoc />}></Route>

                                {/* admin-as */}
                                <Route path="/admin-post-as/*" element={<AdminASComplementForm />}></Route>
                                <Route path="/admin-post-as" element={<AdminASPostForm />}></Route>
                                <Route path="/admin/as" element={<AdminAS />}></Route>

                                {/* admin-sales */}
                                <Route path="/admin-post-sales/*" element={<AdminComplementForm />}></Route>
                                <Route path="/admin-post-sales" element={<AdminPostForm />}></Route>
                                <Route path="/admin/sales" element={<AdminSales />}></Route>
                            </Routes>
                        </BrowserRouter>
                    </RecoilRoot>
                </ChakraProvider>
            </div>
        </ChakraProvider>
    );
}

export default App;
